/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Breakdown of a patient's responsibility for a single service type
 */
export interface PatientResponsibilityBreakdown {
  /** Total amount the patient owes, in cents */
  total: number;
  /** Deductible contribution, in cents */
  deductible: number;
  /** Coinsurance contribution, in cents */
  coinsurance: number;
  /** Coinsurance as a fraction (0.15 = 15%) */
  coinsurance_percent: number;
  /** Copayment contribution, in cents */
  copayment: number;
  /** Fallback (potentially unknown / 'maximum') amount, in cents */
  fallback: number;
}
